import { useState, useCallback, useEffect } from "react";
import { authFetch } from "@/lib/authFetch";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * useDashboardData — fetches dashboard summary + proactive briefing.
 */
export default function useDashboardData() {
  // Sessão UI-1 — campos adicionais (additivos) consumidos pelos novos
  // KpiCards do Dashboard. Nada é renomeado/removido — backward compat.
  const [dashboardData, setDashboardData] = useState({
    pendingTasks: 0,
    activeReminders: 0,
    habitStreak: 0,
    monthBalance: 0,
    // Campos adicionais (UI-1):
    tasksOverdue: 0,
    habitsCheckedToday: 0,
    habitsTotalToday: 0,
    monthIncome: 0,
    monthExpenses: 0,
  });

  const [briefing, setBriefing] = useState(null);

  const fetchDashboardData = useCallback(async () => {
    try {
      const response = await authFetch(`${API_URL}/api/dashboard`);
      if (response.ok) {
        const data = await response.json();
        setDashboardData({
          pendingTasks: data.tasks_summary?.pending || 0,
          activeReminders: data.reminders_today?.length || 0,
          habitStreak: data.habits_today?.checked || 0,
          monthBalance: data.financial_summary?.balance || 0,
          tasksOverdue: data.tasks_summary?.overdue || 0,
          habitsCheckedToday: data.habits_today?.checked || 0,
          habitsTotalToday: data.habits_today?.total || 0,
          monthIncome: data.financial_summary?.income || 0,
          monthExpenses: data.financial_summary?.expenses || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard:", error);
    }
    // Also refresh briefing on every dashboard refresh
    try {
      const response = await authFetch(`${API_URL}/api/assistant/proactive-briefing`);
      if (response.ok) {
        const data = await response.json();
        setBriefing(data);
      }
    } catch (error) {
      console.error("Error fetching briefing:", error);
    }
  }, []);

  const fetchBriefing = useCallback(async () => {
    try {
      const response = await authFetch(`${API_URL}/api/assistant/proactive-briefing`);
      if (response.ok) {
        const data = await response.json();
        setBriefing(data);
      }
    } catch (error) {
      console.error("Error fetching briefing:", error);
    }
  }, []);

  useEffect(() => {
    fetchDashboardData();
    // Refresh every 15 seconds to keep panels always up to date
    const interval = setInterval(fetchDashboardData, 15000);
    return () => clearInterval(interval);
  }, [fetchDashboardData]);

  return { dashboardData, briefing, fetchDashboardData };
}
